// extracted by mini-css-extract-plugin
module.exports = {"menuIconWrapper":"mobile-nav_menuIconWrapper__PbNxk","mobileMenuWrapper":"mobile-nav_mobileMenuWrapper__ZV8sG"};